import React from 'react';

import styles from './team-cards-due-empty.less';

const partyTaco = require('images/home/cards/party-taco.svg');

// TODO: TMON-924 Use Gamma's localize function
interface EmptyProps {
  l?: (key: string) => string;
}
const defaultLocalize = (key: string) => key;

export const Empty: React.StatelessComponent<EmptyProps> = ({
  l = defaultLocalize,
}) => <div className={styles.empty}>{l('no-cards-due')}</div>;

export const EmptyToday: React.StatelessComponent<EmptyProps> = ({
  l = defaultLocalize,
}) => (
  <div className={styles.emptyToday}>
    <img src={partyTaco} alt="" role="presentation" className={styles.image} />
    <div className={styles.title}>{l('due-today-empty')}</div>
    <div className={styles.subtitle}>{l('due-today-empty-subtitle')}</div>
  </div>
);



// WEBPACK FOOTER //
// ./app/scripts/views/home/presentational/team-cards-due-empty.tsx